/* unplugin-vue-components disabled */import { render } from "./formItem.vue?vue&type=template&id=4e0a43c1&scoped=true"
const script = {}

import "./formItem.vue?vue&type=style&index=0&id=4e0a43c1&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0a43c1"]])

export default __exports__